import React, { Component } from "react";
import EndrollAgency from "./EnrollAgency";

class EndrollAgencyContainer extends Component {
    render() {
       return (
          <EndrollAgency {...this.props}/>
       )
    }
  }

export default EndrollAgencyContainer;



// WEBPACK FOOTER //
// ./src/components/EnrollAgencyContainer.js